import { render, staticRenderFns } from "./settings-tab.vue?vue&type=template&id=720d41f1&scoped=true&"
import script from "./settings-tab.vue?vue&type=script&lang=js&"
export * from "./settings-tab.vue?vue&type=script&lang=js&"
import style0 from "./settings-tab.vue?vue&type=style&index=0&id=720d41f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720d41f1",
  null
  
)

export default component.exports